import { useTranslation } from 'react-i18next'

export default function FlowSvg() {
  const { t } = useTranslation()
  const f = (key: string) => t(`caseScoder.flow.${key}`)

  return (
    <svg
      className="w-full h-auto max-w-[1180px] mx-auto block"
      viewBox="0 0 1200 2080"
      xmlns="http://www.w3.org/2000/svg"
      fontFamily="Inter, sans-serif"
    >
      <defs>
        <marker
          id="arrow"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="7"
          markerHeight="7"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#4A5E6D" />
        </marker>
        <marker
          id="arrow-sim"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="7"
          markerHeight="7"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#27AE60" />
        </marker>
        <marker
          id="arrow-nao"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="7"
          markerHeight="7"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#EB5757" />
        </marker>
        <linearGradient id="diamondGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#FEF0DC" />
        </linearGradient>
        <linearGradient id="cardGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#FAFCFC" />
        </linearGradient>
        <filter id="softShadow" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#1B2B3A" floodOpacity="0.10" />
        </filter>
        <filter id="diamondShadow" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="3" stdDeviation="4" floodColor="#F2994A" floodOpacity="0.30" />
        </filter>
        <style>{`
          .node-text { font-family: 'Manrope', sans-serif; font-size: 13px; fill: #1B2B3A; font-weight: 600; }
          .badge-text { font-family: 'Inter', monospace; font-size: 9px; fill: #80D3C9; font-weight: 700; letter-spacing: 0.6px; }
          .decision-text { font-family: 'Manrope', sans-serif; font-size: 13px; fill: #1B2B3A; font-weight: 700; }
          .loop-text { font-family: 'Inter', monospace; font-size: 10px; fill: #EB5757; font-weight: 600; letter-spacing: 0.3px; }
          .branch-label-sim { font-family: 'Inter', monospace; font-size: 12px; fill: #27AE60; font-weight: 700; }
          .branch-label-nao { font-family: 'Inter', monospace; font-size: 12px; fill: #EB5757; font-weight: 700; }
        `}</style>
      </defs>

      {/* 1. JIRA */}
      <rect
        x="290"
        y="120"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="478" y="132" width="40" height="20" rx="10" fill="#1B2B3A" />
      <text x="498" y="146" textAnchor="middle" className="badge-text">
        JIRA
      </text>
      <text x="410" y="178" textAnchor="middle" className="node-text">
        {f('step1Line1')}
      </text>
      <text x="410" y="195" textAnchor="middle" className="node-text">
        {f('step1Line2')}
      </text>

      <line
        x1="410"
        y1="205"
        x2="410"
        y2="266"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* 2. Google Sheets */}
      <rect
        x="290"
        y="270"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="412" y="282" width="106" height="20" rx="10" fill="#1B2B3A" />
      <text x="465" y="296" textAnchor="middle" className="badge-text">
        GOOGLE SHEETS
      </text>
      <text x="410" y="328" textAnchor="middle" className="node-text">
        {f('step2Line1')}
      </text>
      <text x="410" y="345" textAnchor="middle" className="node-text">
        {f('step2Line2')}
      </text>

      <line
        x1="410"
        y1="355"
        x2="410"
        y2="416"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* 3. Slack */}
      <rect
        x="290"
        y="420"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="470" y="432" width="48" height="20" rx="10" fill="#1B2B3A" />
      <text x="494" y="446" textAnchor="middle" className="badge-text">
        SLACK
      </text>
      <text x="410" y="478" textAnchor="middle" className="node-text">
        {f('step3Line1')}
      </text>
      <text x="410" y="495" textAnchor="middle" className="node-text">
        {f('step3Line2')}
      </text>

      <line
        x1="410"
        y1="505"
        x2="410"
        y2="552"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* Decision 1 */}
      <polygon
        points="410,552 540,627 410,702 280,627"
        fill="url(#diamondGrad)"
        stroke="#F2994A"
        strokeWidth="2.5"
        filter="url(#diamondShadow)"
        strokeLinejoin="round"
      />
      <text x="410" y="619" textAnchor="middle" className="decision-text">
        {f('decision1Line1')}
      </text>
      <text x="410" y="637" textAnchor="middle" className="decision-text">
        {f('decision1Line2')}
      </text>

      {/* Loop: AGUARDA 1H */}
      <circle
        cx="730"
        cy="345"
        r="58"
        fill="#FFFFFF"
        stroke="#EB5757"
        strokeWidth="2"
        strokeDasharray="5,4"
      />
      <text x="730" y="343" textAnchor="middle" className="loop-text">
        {f('loopWait')}
      </text>
      <text x="730" y="358" textAnchor="middle" className="loop-text">
        {f('loopTime')}
      </text>

      {/* NÃO path */}
      <text x="572" y="615" className="branch-label-nao">
        {f('no')}
      </text>
      <path d="M 540 627 L 730 627 L 730 405" fill="none" stroke="#EB5757" strokeWidth="2" />
      <path
        d="M 730 287 L 730 90 L 410 90 L 410 116"
        fill="none"
        stroke="#EB5757"
        strokeWidth="2"
        markerEnd="url(#arrow-nao)"
      />

      {/* SIM path */}
      <text x="422" y="728" className="branch-label-sim">
        {f('yes')}
      </text>
      <line x1="410" y1="702" x2="410" y2="755" stroke="#27AE60" strokeWidth="2" />

      {/* Split point */}
      <line x1="410" y1="755" x2="900" y2="755" stroke="#27AE60" strokeWidth="2" />
      <line
        x1="900"
        y1="755"
        x2="900"
        y2="800"
        stroke="#27AE60"
        strokeWidth="2"
        markerEnd="url(#arrow-sim)"
      />
      <line
        x1="410"
        y1="755"
        x2="410"
        y2="800"
        stroke="#27AE60"
        strokeWidth="2"
        markerEnd="url(#arrow-sim)"
      />

      {/* Right track - R1. Google Workspace */}
      <rect
        x="780"
        y="805"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="876" y="817" width="132" height="20" rx="10" fill="#1B2B3A" />
      <text x="942" y="831" textAnchor="middle" className="badge-text">
        GOOGLE WORKSPACE
      </text>
      <text x="900" y="863" textAnchor="middle" className="node-text">
        {f('r1Line1')}
      </text>
      <text x="900" y="880" textAnchor="middle" className="node-text">
        {f('r1Line2')}
      </text>

      <line
        x1="900"
        y1="890"
        x2="900"
        y2="951"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* R2. Google Drive */}
      <rect
        x="780"
        y="955"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="912" y="967" width="96" height="20" rx="10" fill="#1B2B3A" />
      <text x="960" y="981" textAnchor="middle" className="badge-text">
        GOOGLE DRIVE
      </text>
      <text x="900" y="1013" textAnchor="middle" className="node-text">
        {f('r2Line1')}
      </text>
      <text x="900" y="1030" textAnchor="middle" className="node-text">
        {f('r2Line2')}
      </text>

      <line
        x1="900"
        y1="1040"
        x2="900"
        y2="1101"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* R3. Banco Inter */}
      <rect
        x="780"
        y="1105"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="918" y="1117" width="90" height="20" rx="10" fill="#1B2B3A" />
      <text x="963" y="1131" textAnchor="middle" className="badge-text">
        BANCO INTER
      </text>
      <text x="900" y="1163" textAnchor="middle" className="node-text">
        {f('r3Line1')}
      </text>
      <text x="900" y="1180" textAnchor="middle" className="node-text">
        {f('r3Line2')}
      </text>

      {/* Left track - L1. Google Sheets */}
      <rect
        x="290"
        y="805"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="412" y="817" width="106" height="20" rx="10" fill="#1B2B3A" />
      <text x="465" y="831" textAnchor="middle" className="badge-text">
        GOOGLE SHEETS
      </text>
      <text x="410" y="863" textAnchor="middle" className="node-text">
        {f('l1Line1')}
      </text>
      <text x="410" y="880" textAnchor="middle" className="node-text">
        {f('l1Line2')}
      </text>

      <line
        x1="410"
        y1="890"
        x2="410"
        y2="951"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* L2. PDF */}
      <rect
        x="290"
        y="955"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="482" y="967" width="36" height="20" rx="10" fill="#1B2B3A" />
      <text x="500" y="981" textAnchor="middle" className="badge-text">
        PDF
      </text>
      <text x="410" y="1005" textAnchor="middle" className="node-text">
        {f('l2Line1')}
      </text>

      <line
        x1="410"
        y1="1040"
        x2="410"
        y2="1092"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* Decision 2 */}
      <polygon
        points="410,1092 540,1167 410,1242 280,1167"
        fill="url(#diamondGrad)"
        stroke="#F2994A"
        strokeWidth="2.5"
        filter="url(#diamondShadow)"
        strokeLinejoin="round"
      />
      <text x="410" y="1159" textAnchor="middle" className="decision-text">
        {f('decision2Line1')}
      </text>
      <text x="410" y="1177" textAnchor="middle" className="decision-text">
        {f('decision2Line2')}
      </text>

      {/* Loop Circle 2 */}
      <circle
        cx="680"
        cy="975"
        r="68"
        fill="#FFFFFF"
        stroke="#EB5757"
        strokeWidth="2"
        strokeDasharray="5,4"
      />
      <text x="680" y="955" textAnchor="middle" className="loop-text">
        {f('loop2Line1')}
      </text>
      <text x="680" y="971" textAnchor="middle" className="loop-text">
        {f('loop2Line2')}
      </text>
      <text x="680" y="987" textAnchor="middle" className="loop-text">
        {f('loop2Line3')}
      </text>
      <text x="680" y="1003" textAnchor="middle" className="loop-text">
        {f('loop2Line4')}
      </text>

      {/* NÃO path 2 */}
      <text x="572" y="1155" className="branch-label-nao">
        {f('no')}
      </text>
      <path d="M 540 1167 L 680 1167 L 680 1043" fill="none" stroke="#EB5757" strokeWidth="2" />
      <path
        d="M 680 907 L 680 785 L 410 785 L 410 801"
        fill="none"
        stroke="#EB5757"
        strokeWidth="2"
        markerEnd="url(#arrow-nao)"
      />

      {/* SIM path 2 */}
      <text x="422" y="1268" className="branch-label-sim">
        {f('yes')}
      </text>
      <line
        x1="410"
        y1="1242"
        x2="410"
        y2="1296"
        stroke="#27AE60"
        strokeWidth="2"
        markerEnd="url(#arrow-sim)"
      />

      {/* L3. HTML */}
      <rect
        x="290"
        y="1300"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="478" y="1312" width="40" height="20" rx="10" fill="#1B2B3A" />
      <text x="498" y="1326" textAnchor="middle" className="badge-text">
        HTML
      </text>
      <text x="410" y="1350" textAnchor="middle" className="node-text">
        {f('l3Line1')}
      </text>

      <line
        x1="410"
        y1="1385"
        x2="410"
        y2="1437"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* Decision 3 */}
      <polygon
        points="410,1437 540,1512 410,1587 280,1512"
        fill="url(#diamondGrad)"
        stroke="#F2994A"
        strokeWidth="2.5"
        filter="url(#diamondShadow)"
        strokeLinejoin="round"
      />
      <text x="410" y="1504" textAnchor="middle" className="decision-text">
        {f('decision2Line1')}
      </text>
      <text x="410" y="1522" textAnchor="middle" className="decision-text">
        {f('decision2Line2')}
      </text>

      {/* SIM path 3 */}
      <text x="422" y="1613" className="branch-label-sim">
        {f('yes')}
      </text>
      <line
        x1="410"
        y1="1587"
        x2="410"
        y2="1641"
        stroke="#27AE60"
        strokeWidth="2"
        markerEnd="url(#arrow-sim)"
      />

      {/* L4. Banco Inter */}
      <rect
        x="290"
        y="1645"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="428" y="1657" width="90" height="20" rx="10" fill="#1B2B3A" />
      <text x="473" y="1671" textAnchor="middle" className="badge-text">
        BANCO INTER
      </text>
      <text x="410" y="1695" textAnchor="middle" className="node-text">
        {f('l4Line1')}
      </text>

      <line
        x1="410"
        y1="1730"
        x2="410"
        y2="1791"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* L5. API GOV */}
      <rect
        x="290"
        y="1795"
        width="240"
        height="85"
        rx="10"
        fill="url(#cardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="452" y="1807" width="66" height="20" rx="10" fill="#1B2B3A" />
      <text x="485" y="1821" textAnchor="middle" className="badge-text">
        API GOV
      </text>
      <text x="410" y="1845" textAnchor="middle" className="node-text">
        {f('l5Line1')}
      </text>

      <line
        x1="410"
        y1="1880"
        x2="410"
        y2="1941"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#arrow)"
      />

      {/* L6. Final node */}
      <rect
        x="290"
        y="1945"
        width="240"
        height="92"
        rx="10"
        fill="#00A693"
        stroke="#007D6E"
        strokeWidth="2"
        filter="url(#softShadow)"
      />
      <rect x="368" y="1957" width="132" height="20" rx="10" fill="#1B2B3A" />
      <text x="434" y="1971" textAnchor="middle" className="badge-text">
        GOOGLE WORKSPACE
      </text>
      <text
        x="410"
        y="2001"
        textAnchor="middle"
        fontFamily="Manrope, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#FFFFFF"
      >
        {f('finalLine1')}
      </text>
      <text
        x="410"
        y="2019"
        textAnchor="middle"
        fontFamily="Manrope, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#FFFFFF"
      >
        {f('finalLine2')}
      </text>
    </svg>
  )
}
